import '.c2{position:relative;}.ssr-plugin'
import '.i5{width:64px;}.ssr-plugin'
import '.i6{height:64px;}.ssr-plugin'
import '.bp{flex-shrink:0;}.ssr-plugin'
import '.i{position:absolute;}.ssr-plugin'
import '.i7{bottom:-4px;}.ssr-plugin'
import '.c4{right:-4px;}.ssr-plugin'
import '.dd{border-radius:50%;}.ssr-plugin'
import '.i8{border:2px solid var(--shades-white);}.ssr-plugin'
import '.m{overflow:hidden;}.ssr-plugin'
import '.i9{width:32px;}.ssr-plugin'
import '.ia{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="c2 i5 i6 bp"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="i i7 c4 dd i8 m i9 ia"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
